
import _ from 'lodash'
import math from '@/utils/math'

export default {
  computed: {
  },
  methods: {
    /**
     * listIndex 関連の初期化を行う
     * @param {Number} index 配列のindex
     * @param {Number} mode 画面モード 既定は 0
     */
    initializeListIndex: function () {
      // ページ送りのデータ設定
      // historyにページ送りしてよいかのフラグが既にある場合、その値を使う。
      // ない場合は、現在のlistIndexが0以上であればtrue、それ以外はfalseとして、historyに保存する。
      if (history.state && history.state.canMoveData != null) {
        this.canMoveData = history.state.canMoveData
      } else {
        const listIndex = this.storePath + '.listIndex'
        if (_.get(this.$store.state, listIndex, -1) >= 0) {
          this.canMoveData = true
        }
        history.replaceState({
          ...window.history.state,
          canMoveData: this.canMoveData
        }, '')
      }
    },
    /**
     * 一覧の配列 から listIndex を算出する
     * @param {function} compareFunc 配列から対象データを特定するための条件
     */
    $_detailUtil_onGetDetailData: function (compareFunc) {
      const listIndexStorePath = this.storePath + '/listIndex'
      const currentPageStorePath = this.storePath + '/currentPage'
      // listIndexの更新
      let listIndex = -1
      listIndex = this.sortedList.findIndex(compareFunc)
      listIndex = listIndex === -1 ? 0 : listIndex

      this.$store.dispatch({
        type: 'set',
        states: {
          [listIndexStorePath]: listIndex,
          [currentPageStorePath]: math.divide([listIndex, this.size], math.FLOOR, 0)
        }
      })
    }
  },
  beforeRouteUpdate (to, from, next) {
    this.initializeListIndex()
    next()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.initializeListIndex()
    })
  }
}
